import { render, staticRenderFns } from "./SideOverlay.vue?vue&type=template&id=6bef0328"
import script from "./SideOverlay.vue?vue&type=script&lang=js"
export * from "./SideOverlay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports